import React, { useEffect, useState } from "react";
import { Col } from "reactstrap";
import TopCards from "./TopCards";
import AppStatusAndAnalysis from "./AppStatusAndAnalysis";
import useGetAuthed from "../../../helpers/hooks/useGetAuthed";
import TopTen from "./TopTen";

const Dashboard = () => {
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCurrentDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1); 
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
    };

//   const getCurrentDateTime = () => {
//     const d = new Date();
//     d.setDate(d.getDate()); 
//     const year = d.getFullYear();
//     const month = (d.getMonth() + 1).toString().padStart(2, "0");
//     const day = d.getDate().toString().padStart(2, "0");
//     const hours = d.getHours().toString().padStart(2, "0");
//     const minutes = d.getMinutes().toString().padStart(2, "0");
//     const seconds = d.getSeconds().toString().padStart(2, "0");
//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// };

// const currentDateTime = getCurrentDateTime();
// console.log(currentDateTime);


  const getThreeMonthsBack = (endDate) => {
    const currentDate = new Date(endDate);
    currentDate.setMonth(currentDate.getMonth() - 3);
    return formatDate(currentDate);
  };

  const [loanStatsData, setLoanStatsData] = useState(null);
  const [topTen, setTopTen] = useState(null);
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [startDate, setStartDate] = useState('2020-01-01');//getThreeMonthsBack(getCurrentDate()));

  const [authData, errorAuth, loadingAuth, callAuth] = useGetAuthed(
    `loan_stats/?start_date=${startDate}&end_date=${endDate}`,
    true,
    "loan"
  );

  const [authData3, errorAuth3, loadingAuth3, callAuth3] = useGetAuthed(
    `top_10?start_date=${startDate}&end_date=${endDate}`,
    true,
    "loan"
  );

  useEffect(() => {
    if (authData) {
      setLoanStatsData(authData);
    }
  }, [authData, errorAuth]);

  useEffect(() => {
    if (authData3) {
      setTopTen(authData3);
    }
  }, [authData3, errorAuth3]);

  useEffect(() => {
    if (startDate && endDate) {
      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);
      callAuth(
        `loan_stats/?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      callAuth3(
        `top_10?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
    }
  }, [startDate, endDate]);

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    const selectedEndDate = event.target.value;
    setEndDate(selectedEndDate);
    const newStartDate = getThreeMonthsBack(selectedEndDate);
    setStartDate(newStartDate);
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          marginBottom: "10px",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <h4 style={{ fontWeight: "bold" }}>Dashboard</h4>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
              width: "225px",
            }}
          >
            <span style={{ marginRight: "5px" }}>Start Date:</span>
            <input
              type="date"
              value={startDate}
              onChange={handleStartDateChange}
              style={{
                padding: "10px",
                color: "#a3a4a5",
                backgroundColor: "#0000",
                border: "1px solid #8aa2b4",
                borderRadius: "10px",
              }}
            />
          </div>
          <div
            style={{ display: "flex", alignItems: "center", width: "225px" }}
          >
            <span style={{ marginRight: "5px" }}>End Date:</span>
            <input
              type="date"
              value={endDate}
              onChange={handleEndDateChange}
              style={{
                padding: "10px",
                color: "#a3a4a5",
                backgroundColor: "#0000",
                border: "1px solid #8aa2b4",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
      </div>

      <Col xl={12}>
        <TopCards loanStatsData={loanStatsData} loading={loadingAuth} />
        <AppStatusAndAnalysis
          loanStatsData={loanStatsData}
          loading={loadingAuth}
        />
      </Col>
      <TopTen topten={topTen} loading={loadingAuth3} />
    </React.Fragment>
  );
};

export default Dashboard;
